import { Div, Ref, Label, TextInput, Select, MultilineInput } from "@tblabs/truffle";
import { primitive } from "@tblabs/truffle/Core/primitive";


export class FormTextInputHalfWidth extends Div
{
    constructor(label: string, input: Ref<string>)
    {
        super("form__group");

        this.Append(
            new Label(label).Class("form__label"),
            new TextInput(input).Class("form__input")//.Attribute("data-testid", label)
                .ApplyClass(input, v => v == "", "form__input--invalid", false)
        );
    }
}

export class FormTextInputFullWidth extends Div
{
    constructor(label: string, input: Ref<string>, placeholder?: string)
    {
        super("form__group form__group--full");

        this.Append(
            new Label(label).Class("form__label"),
            new TextInput(input).Class("form__input")//.Attribute("data-testid", label)
                .Placeholder(placeholder)
                .ApplyClass(input, v => v == "", "form__input--invalid", false)
        );
    }
}

export class FormMultilineInputFullWidth extends Div
{
    constructor(label: string, input: Ref<string>, placeholder?: string)
    {
        super("form__group form__group--full");

        this.Append(
            new Label(label).Class("form__label"),
            new MultilineInput(input).Rows(4).Class("form__input")//.Attribute("data-testid", label)
            .Placeholder(placeholder)
                .ApplyClass(input, v => v == "", "form__input--invalid", false)
        );
    }
}

export class FormSelectHalfWidth<T extends primitive> extends Div
{
    constructor(label: string, input: Ref<T>, options: Record<string, T>)
    {
        super("form__group");
       
        const firstOptionKey = Object.keys(options)[0];

        if (!input.value)
        {
            input.value = options[firstOptionKey];
        }

        this.Append(
            new Label(label).Class("form__label"),
            new Select<T>(input, options)
                .Class("form__input form__input-select")//.Attribute("data-testid", label)
        );
    }
}

export class FormSelectFullWidth<T extends primitive> extends Div
{
    constructor(label: string, input: Ref<T>, options: Record<string, T>)
    {
        super("form__group form__group--full");

        const firstOptionValue = Object.keys(options)[0];

        if (!input.value)
        {
            input.value = options[firstOptionValue];
        }

        this.Append(
            new Label(label).Class("form__label"),
            new Select<T>(input, options).Class("form__input form__input-select")
            //.Attribute("data-testid", label)
        );
    }
}
